<template>
    <section style="min-height:600px" class="product_details">
      
         <div v-if="!DBitems || loading" class="d-flex flex-row justify-content-center loading_card" style="height:600px;align-items: center;">
            <div class="loading_card_spinner">
            <hollow-dots-spinner class="loading_card_spinner" :animation-duration="1000" :dot-size="35" :dots-num="3"
                color="var(--primary-color)" />
                </div>

        </div>

        <div v-else>
            <div class="container mt-4">
                <div class="row">
                    <!-- القسم اليساري -->
                    <div class="col-12 col-md-6 mb-3">
                        <div class="p-3">
                            <!-- ✅ الديسكتوب -->
                            <div class=" d-md-block" style="display:none">
                                <div class="image-wrapper d-flex justify-content-center align-items-center mb-3">
                                    <img :src="DBitems.images.images[0].src" class="custom-img-large"
                                        :alt="DBitems.product.name" :data-img="DBitems.images.images[0].src"
                                        @click="openImageModal(DBitems.images.images[0].src)"
                                        style="cursor: pointer;" />
                                    <div class="hover-icon" :data-img="DBitems.images.images[0].src"
                                        @click="openImageModal(DBitems.images.images[0].src)">
                                        <i class="bi bi-zoom-in"></i>
                                    </div>
                                </div>

                                <div class="row product_images">
                                    <div v-for="(item, index) in DBitems.images.images" :key="index"
                                    v-if="index!=0"
                                        class="col-6 image-wrapper">

                                        <img  :src="item.src" class="custom-img-small" alt="صورة" :data-img="item.src"
                                            @click="openImageModal(item.src)" style="cursor: pointer;" />
                                        <div class="hover-icon2">

                                            <i class="bi bi-zoom-in"></i>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- ✅ الموبايل -->
                            <div class="d-block d-md-none">
                                <VueSlickCarousel ref="carousel" v-bind="settings" id="mobileCarousel">
                                    <div v-for="(item, index) in DBitems.images.images" :key="index"
                                        class="carousel-item position-relative">
                                        <img :src="item.src" class="d-block mx-auto w-50 mobile_product_image"
                                           />
                                        <div class="search" 
                                        @click="openImageModal(item.src)">
                                            <i class="bi bi-search"></i>
                                        </div>
                                    </div>
                                </VueSlickCarousel>

                                <div class="mt-3 d-flex justify-content-center align-items-center gap-3">
                                    <button @click="showNext" class="btn btn-sm" type="button" data-bs-target="#mobileCarousel"
                                        data-bs-slide="prev">
                                        <i class="bi bi-chevron-left"></i>
                                    </button>
                                    <div id="carousel-counter" class="small text-muted">1 / {{
                                        DBitems.images.images.length }}</div>
                                    <button @click="showPrev" class="btn btn-sm" type="button" data-bs-target="#mobileCarousel"
                                        data-bs-slide="next">
                                        <i class="bi bi-chevron-right"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- القسم اليميني -->
                    <div class="col-12 col-md-6 mb-3">
                        <div class="p-3">
                            <h2 class="product_title_page">{{ DBitems.product.name }}</h2>

                            <p v-if="selectOption && DBitems.product.range_price">
                                {{ (DBitems.product.range_price.min_price *
                                    $store.state.rate).toFixed($store.state.digit_price) }}
                                {{ $store.state.UnitPrice }} -
                                {{ (DBitems.product.range_price.max_price *
                                    $store.state.rate).toFixed($store.state.digit_price) }}
                                {{ $store.state.UnitPrice }}
                            </p>

                            <p v-else-if="selectOption">{{ $t('selectOption') }}</p>

                            <p v-else-if="offer_price == 0">
                                {{ (price * $store.state.rate).toFixed($store.state.digit_price) }} {{
                                    $store.state.UnitPrice }}
                            </p>

                            <p v-else>
                                {{ (offer_price * $store.state.rate).toFixed($store.state.digit_price) }} {{
                                    $store.state.UnitPrice }}
                                <del class="text-red-600">
                                    {{ (price * $store.state.rate).toFixed($store.state.digit_price) }} {{
                                        $store.state.UnitPrice }}
                                </del>
                            </p>

                            <p v-if="DBitems.product.is_offer">
                                {{ $t('discount') }}: {{ DBitems.product.discount }}%
                            </p>

                            <div class="orderInfo d-flex flex-row justify-content-between mt-1"
                                v-if="DBitems.product.is_offer">
                                <h4 style="color: var(--primary-color)">{{ $t("offerEnd") }} :</h4>
                                <h5 style="color: var(--primary-color)">{{ DBitems.product.offer_end }}</h5>
                            </div>

                            <!-- الخيارات -->
                            <div v-if="DBitems.options.options.length > 0">
                                <div v-for="(item, index) in DBitems.options.options" :key="index">
                                    <h6 class="mb-3">{{ item.name }}</h6>
                                    <div class="mb-4 d-flex flex-wrap gap-2">
                                        <label :class="'btn option-btn selected option' + item.id"
                                            v-for="(item1, idx) in item.option_values.select_values" :key="idx"
                                            :for="item1.id + 'select' + index" :id="'select_value' + item1.id">
                                            <input type="radio" :id="item1.id + 'select' + index"
                                                :name="'select' + item.id" :value="item1.id" :title="$t('SelectOne')"
                                                @change="upadateprice($event, item.id, item1.id)"
                                                :class="'option_value_radio ' + item.id + 'select_value' + index"
                                                style="display:none" />
                                            {{ item1.name }}
                                        </label>
                                    </div>
                                </div>
                            </div>

                            <!-- الكمية -->
                            <h6 class="mb-3">{{ $t('quantity') }}</h6>

                            <div v-if="loading_price" class="empty text-center center-text">
                                <img src="https://etrolley.net/pet_shop/assets/images/ajax-loader.gif" />
                            </div>

                            <div v-else-if="(quanity === 0 || max_quanity === 0) && !selectOption && !loading_price"
                                class="flex items-center">
                                <h5 class="text-lg font-semibold me-2">{{ $t("NoQuantity") }}:</h5>
                            </div>

                            <div v-else-if="selectOption && !loading_price" class="mb-4 quantity" style="width: 150px;">
                                <a class="btn btn-outline-secondary" :title="$t('select option')">-</a>
                                <input min="1" name="quantity" value="1" title="Qty" type="number" id="quantityInput"
                                    class="form-control text-center small-input" />
                                <a class="btn btn-outline-secondary" :title="$t('select option')">+</a>
                            </div>

                            <div v-else-if="!loading_price" class="mb-4 quantity" style="width: 150px;">
                                <button class="btn btn-outline-secondary" @click="decrementClick()">-</button>
                                <input min="1" name="quantity" :value="counterVal" title="Qty" type="number"
                                    id="quantityInput" class="form-control text-center small-input" />
                                <button class="btn btn-outline-secondary" @click="incrementClick()">+</button>
                            </div>

                            <div class="d-grid gap-3 mb-4">
                                <button class="btn btn-outline-dark add-to-cart-btn" id="#addToCart" v-if="quanity != 0"
                                    @click="addToCart">
                                    <i id="icon_loading" style="display:none" class="fa fa-spinner fa-spin icon_loading"
                                        aria-hidden="true"></i>

                                    {{ $t("Addtocart") }}
                                </button>
                                
                                <button v-else class="btn btn-outline-dark add-to-cart-btn" id="#addToCart" disabled title="hhhhhh">
                                    <i id="icon_loading" style="display:none" class="fa fa-spinner fa-spin icon_loading"
                                        aria-hidden="true"></i>

                                    {{ $t("please select option to add to cart") }}
                                </button>
                            </div>

                            <p style="color: rgba(37, 37, 37, 0.75);" v-html="DBitems.product.description"></p>
                        </div>
                    </div>
                </div>

                <hr />

                <!-- ✅ مودال الصورة -->
                <div class="modal" id="imageModal" tabindex="-1">
                    <div class="modal-dialog modal-dialog-centered modal-lg model_product_image">
                        <div @click="closeImageModal" class="modal-content bg-transparent border-0 position-relative">
                            <button @click="closeImageModal" type="button"
                                class="btn-close position-absolute top-0 end-0 m-2" data-bs-dismiss="modal"
                                aria-label="Close"></button>
                            <div class="modal-body p-0 text-center">
                                <img id="modalImage" src="" class="img-fluid rounded" alt="صورة مكبرة" />
                            </div>
                        </div>
                    </div>
                </div>

                <!-- منتجات مشابهة -->
                <div class="container py-5">
                    <p class="mb-4" style="font-size: 30px;">{{ $t('You may also like') }}</p>
                    <div class="row row-cols-2 row-cols-md-4 row-cols-lg-4 g-4">
                        <product v-for="(item, index) in DBitems.similar_products" :key="index" :name="item.name"
                            :description="item.description" :is_favorit="item.is_favorit" :image="item.thump"
                            :old_price="item.old_price" :new_price="item.new_price" :productid="item.id"
                            :rate="item.rate" :count_view="item.count_views" :is_option="item.is_option"
                            :is_offer="item.is_offer" :unit="item.unit" :new="item.is_new" :fetuered="item.is_fetured"
                            :discount="item.discount" :qnt="item.qnt" :min_qnt="item.min_qnt" :max_qnt="item.max_qnt"
                            :note="item.note" :range_price="item.range_price" />
                    </div>
                </div>
            </div>
        </div>
        <div v-if="validateMessage!=''" class="validate_message">
            <div class="d-flex justify-content-between">
                <h2 class="cart-notification__heading caption-large text-body">
                    <i class="bi bi-check"></i>
                    {{ validateMessage }}
                </h2>
                 <h2 @click="validateMessage=''" class="cart-notification__heading caption-large text-body">
                    <i class="bi bi-x-lg"></i>
                </h2>
            </div>

            <div class="validate_body" >
                <img v-if="this.DBitems.images" :src="this.DBitems.images.images[0].src" alt="Product">
                <div style="text-align: left;">
                    <p style="margin:0px 5px;font-weight:400">{{ this.DBitems.product.name }}</p>
                    <p style="margin: 0 5px;font-weight:200">{{ $t('quantity') }}: {{ counterVal }}</p>
                </div>

            </div>
            <div class="btn_message">
                <button class="btn btn-outline-dark add-to-cart-btn"
                    v-if="this.$localStorage.get(this.$store.storeName) == null" @click="confirmOrder_guest()">

                    {{ $t('Procced to Checkout') }}
                </button>
                <button class="btn btn-outline-dark add-to-cart-btn" v-else @click="confirmOrder()">

                    {{ $t('Procced to Checkout') }}
                </button>
                <button @click="$router.push({
                    name: 'shoppingCart',
                    params: {
                        storeName: $store.storeName,
                                               lang: $i18n.locale
                    },
                });" class="btn btn-outline-dark buy-now-btn">


                    {{ $t('view cart') }}
                </button>
                <router-link :to="{
                    name: 'home',
                    params: { storeName: this.$store.storeName, lang: $i18n.locale },
                }" style="color:grey">{{ $t('Continu Shopping') }}
                </router-link>
            </div>
        </div>

        <div class="modal" style="display: none;" id="imageModal" tabindex="-1" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-lg">
                <div class="modal-content bg-transparent border-0 position-relative">
                    <button type="button" class="btn-close position-absolute top-0 end-0 m-2" data-bs-dismiss="modal"
                        aria-label="Close"></button>
                    <div class="modal-body p-0 text-center">
                        <img id="modalImage" src="" class="img-fluid rounded" alt="صورة مكبرة" />
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import product from "../components/one_product.vue";
import VueSlickCarousel from 'vue-slick-carousel';
import 'vue-slick-carousel/dist/vue-slick-carousel.css';
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css';
import { HalfCircleSpinner, HollowDotsSpinner, CirclesToRhombusesSpinner } from "epic-spinners";


export default {
    components: { product, HalfCircleSpinner, HollowDotsSpinner, CirclesToRhombusesSpinner, VueSlickCarousel },

    data: function () {
        return {
            loading_price: false,
            counterVal: 1,
            loginVodal: false,
            loginMassage: "",
            old_qnt: 0,
            currentId: null,
            width: 600,
            height: 350,
            DBitems: null,
            loading: false,
            loading_checkout: false,
            options: [],
            selectedOptionArray: [],
            price: 0,
            quanity: 0,
            max_quanity: 0,
            min_quanity: 0,
            Firstquanity: 0,
            finalOptions: 0,
            checked: [],
            validateMessage: "",
            selectOption: false,
            images: null,
            count_images: null,
            fav: false,
            offer_price: 0,
            note: "",
            addeval: false
        };
    },
    created() {

       this.$store.state.showHeader = true;
        this.$store.state.showFooter = true;

        this.loading = true;
        this.axios
            .get(
                this.$store.state.base_api_url +
                this.$store.storeName +
                "/product/theme5/" +
                this.$route.params.id,
                {
                    headers: {
                        "Accept-Language": this.$i18n.locale,
                        Authorization:
                            "Bearer " + this.$localStorage.get(this.$store.storeName)
                    }
                }
            )
            .then(response => {
                this.checked = [];
                this.DBitems = response.data.data;
                if (this.DBitems.product.seo_title)
                    document.title = this.DBitems.product.seo_title;
                else
                    document.title = this.DBitems.product.name;
                if (this.DBitems.product.seo_description)
                    document.getElementById("description_meta").content = this.DBitems.product.seo_description;
                if (this.DBitems.product.seo_keyword)
                    document.getElementById("keywords_meta").content = this.DBitems.product.seo_keyword;
                this.fav = this.DBitems.product.is_favorit;
                this.images = response.data.data.images.images;
                // this.old_images=response.data.data.images.images;
                this.count_images = response.data.data.images.images.length
                var option1 = this.DBitems.options.options;
                var option2 = this.DBitems.options_check.options;
                for (var i = 0; i < option1.length; i++) {
                    //if option  not empty
                    if (option1[i].option_values.select_values != null) {
                        // if select
                        var element = {};
                        element.value_id = null;//option1[i].option_values.select_values[0].id;
                        element.option_id = option1[i].id;
                        this.options.push(element);
                        ///console.log(this.options.length +"iam theeeeeeeeeeeeeeer")
                    }
                }

                for (var i = 0; i < option2.length; i++) {
                    // if checkbox
                    var checked = {};
                    checked.id = option2[i].id;
                    checked.value = false;
                    this.checked.push(checked);
                    //console.log(this.checked)
                }

                //console.log(this.options)
            })
            .then(() => {
                this.loading = false;
                if (this.options.length != 0) {
                    this.selectOption = true;

                }
                else if (this.options.length == 0) {
                    // if we not found select options
                    //console.log("hiiiiiiiiii created" + this.DBitems.product.quanity);
                    this.price = this.DBitems.product.sale_price;
                    this.offer_price = this.DBitems.product.offer_price;
                    this.quanity = this.DBitems.product.quantity;
                    this.max_quanity = this.DBitems.product.quantity;
                    this.min_quanity = 1;
                    if (this.DBitems.product.min_qnt)
                        this.min_quanity = this.DBitems.product.min_qnt;
                    if (this.DBitems.product.max_qnt > 0)
                        this.max_quanity = this.DBitems.product.max_qnt;
                    this.Firstquanity = this.DBitems.product.quantity;

                    /////////////nottttttttttttttttttteeeeeeeeeeeeeeeeeeee////////////
                    var checked_true = [];
                    for (var i = 0; i < this.checked.length; i++) {
                        if (this.checked[i].value == true) {
                            checked_true.push(this.checked[i].id);
                        }
                    }
                    let S_name_full =
                        this.$store.storeName +
                        "/" +
                        this.$route.params.id +
                        this.finalOptions +
                        checked_true;

                    let S_name2 =
                        this.$store.storeName +
                        "/" +
                        this.$route.params.id +
                        this.finalOptions;
                    console.log("S_name " + S_name2);

                    let qun = this.quanity;
                    let min_qun = this.min_quanity;
                    let max_qun = this.max_quanity;
                    let AllCookies = this.$cookies.keys();
                    for (let i = 0; i < AllCookies.length; i++) {
                        if (AllCookies[i].includes(S_name2)) {
                            // if (AllCookies[i] == S_name_full) {
                            //  console.log("hii i am there ");
                            //} else {
                            this.old_qnt = this.$cookies.get(AllCookies[i]).quantity;
                            qun = qun - this.$cookies.get(AllCookies[i]).quantity;
                            min_qun = min_qun - this.$cookies.get(AllCookies[i]).quantity;
                            if (min_qun < 0) {
                                min_qun = 1;
                            }
                            if (max_qun != -1)
                                max_qun = max_qun - this.$cookies.get(AllCookies[i]).quantity;
                            if (max_qun == -1) {
                                max_qun = -1;
                            }
                            else if (max_qun <= 0 && max_qun != -1) {
                                max_qun = 0;
                            }
                            console.log(
                                this.$cookies.get(AllCookies[i]).quantity + " quuuuunb" + qun
                            );
                            // }
                        }
                    }
                    this.quanity = qun;
                    this.min_quanity = min_qun;
                    this.max_quanity = max_qun;

                }
                if (this.min_quanity > 0) {
                    this.counterVal = this.min_quanity;
                    this.price *= this.counterVal;
                    this.offer_price *= this.counterVal;
                }
            });


        //counter value 


        //end counter value
    },
    methods: {
         showNext() {
        this.$refs.carousel.next()
      },
       showPrev() {
        this.$refs.carousel.prev()
      },
        openImageModal(img) {
            document.getElementById('modalImage').src = img;
            document.getElementById('imageModal').style = "display:block"
        },
        closeImageModal() {
            console.log("hhhhhhhhhhhhhhhhhhhhhhhhh")
            document.getElementById('modalImage').src = null;
            document.getElementById('imageModal').style = "display:none";
        },
        confirmOrder() {
          this.$router.push({
                            name: "confirmOrder",
                            params: { storeName: this.$store.storeName, lang: this.$i18n.locale },
                        });
        },
        confirmOrder_guest() {
             this.$router.push({
                            name: "guest_confirmOrder",
                            params: { storeName: this.$store.storeName, lang: this.$i18n.locale },
                        });
        },
        change_image(index, src) {
            console.log('src ', src)
            for (var i = 0; i < this.images.length; i++) {
                document.getElementById('image' + i).style = "border:1px solid transperent !important";
            }
            document.getElementById('image' + index).style = "border:1px solid var(--primary-color) !important";
            //document.getElementById('product_img').src=src;
            //  this.first_image=src;
            document.getElementById("main_image_product").src = src

        },
        incrementClick() {


            if (this.quanity > 0) {
                console.log("*************** max qnt   " + this.max_quanity + " ");
                if (this.counterVal < this.quanity && this.counterVal < this.max_quanity) {
                    ++this.counterVal;
                    this.price = this.price / (this.counterVal - 1) + this.price;
                    if (this.offer_price > 0) {
                        this.offer_price =
                            this.offer_price / (this.counterVal - 1) + this.offer_price;
                        /*   this.offer_price =
                          this.price - (this.DBitems.product.discount / 100) * this.price;*/
                    }
                }
            } else {
                ++this.counterVal;
                this.price = this.price / (this.counterVal - 1) + this.price;
                if (this.offer_price > 0) {
                    this.offer_price =
                        this.offer_price / (this.counterVal - 1) + this.offer_price;
                    /* this.offer_price =
                      this.price - (this.DBitems.product.discount / 100) * this.price;*/
                }
            }
            //}
        },
        decrementClick() {
            if (this.counterVal > 1 && this.counterVal > this.min_quanity) {
                --this.counterVal;
                //this.price = this.price/2
                this.price = this.price - this.price / (this.counterVal + 1);
                if (this.offer_price > 0) {
                    this.offer_price =
                        this.offer_price - this.offer_price / (this.counterVal + 1);
                    /*    this.offer_price =
                      this.price - (this.DBitems.product.discount / 100) * this.price;*/
                }
            }
        },
        updatedata() {

            this.loading = true;
            this.axios
                .get(
                    this.$store.state.base_api_url +
                    this.$store.storeName +
                    "/product/theme5/" +
                    this.$route.params.id,
                    {
                        headers: {
                            "Accept-Language": this.$i18n.locale,
                            Authorization:
                                "Bearer " + this.$localStorage.get(this.$store.storeName)
                        }
                    }
                )
                .then(response => {
                    this.DBitems = response.data.data;
                    if (this.DBitems.product.seo_title)
                        document.title = this.DBitems.product.seo_title;
                    else
                        document.title = this.DBitems.product.name;
                    if (this.DBitems.product.seo_description)
                        document.getElementById("description_meta").content = this.DBitems.product.seo_description;
                    if (this.DBitems.product.seo_keyword)
                        document.getElementById("keywords_meta").content = this.DBitems.product.seo_keyword;
                    this.images = response.data.data.images.images;

                    this.fav = this.DBitems.product.is_favorit;
                })
                .then(() => (this.loading = false));

            //this.$refs.childref.update(this.categoryID)
            this.$store.state.langchange = false;
        },
        upadateprice(event, option_id, select_id) {
            this.loading_price = true;
            var element = document.getElementById('select_value' + select_id)

            console.log(element, '???????/')
            var collections = document.getElementsByClassName("option" + option_id);
            for (var i = 0; i < collections.length; i++) {
                if (collections[i])
                    collections[i].classList.remove('active')
            }
            if (element) {
                element.classList.add('active');
            }

            for (var i = 0; i < this.options.length; i++) {
                if (this.options[i].option_id == option_id) {
                    this.options[i].value_id = event.target.value;
                    if (this.selectedOptionArray.length < this.options.length) {
                        //if (!this.selectedOptionArray.includes(this.options[i].option_id)) {
                        this.selectedOptionArray.push(this.options[i].option_id);
                        //}
                    }
                }
            }
            //console.log(this.options.length  +" hii " +this.selectedOptionArray.length)
            if (this.options.length == this.selectedOptionArray.length) {
                this.selectOption = false;

                var options = this.options;
                this.axios
                    .post(
                        this.$store.state.base_api_url +
                        this.$store.storeName +
                        "/product_price/" +
                        this.$route.params.id,
                        {
                            options
                        },
                        {
                            headers: {
                                "Accept-Language": this.$i18n.locale
                            }
                        }
                    )
                    .then(response => {
                        this.price = response.data.data.price;
                        this.offer_price = response.data.data.new_price;
                        this.quanity = response.data.data.quanity;
                        this.max_quanity = response.data.data.quanity;
                        this.min_quanity = 1;
                        if (response.data.data.min_qnt > 1)
                            this.min_quanity = response.data.data.min_qnt;
                        if (response.data.data.max_qnt > 0)
                            this.max_quanity = response.data.data.max_qnt;
                        this.Firstquanity = response.data.data.quanity;
                        this.finalOptions = response.data.data.final_option;
                        for (var i = 0; i < this.checked.length; i++) {
                            this.checked[i].value = false;
                        }
                        if (response.data.data.image) {
                            if (this.images.length > this.count_images)
                                this.images.shift();
                            this.images.unshift(

                                {
                                    id: '1',
                                    src: response.data.data.image,
                                    thumbnail: response.data.data.image
                                }

                            )
                        }

                        this.note = "";
                        var checked_true = [];
                        for (var i = 0; i < this.checked.length; i++) {
                            if (this.checked[i].value == true) {
                                checked_true.push(this.checked[i].id);
                            }
                        }
                        let S_name_full =
                            this.$store.storeName +
                            "/" +
                            this.$route.params.id +
                            this.finalOptions +
                            checked_true;

                        let S_name2 =
                            this.$store.storeName +
                            "/" +
                            this.$route.params.id +
                            this.finalOptions;
                        console.log("S_name " + S_name2);

                        let qun = this.quanity;
                        let min_qun = this.min_quanity;
                        let max_qun = this.max_quanity;

                        let AllCookies = this.$cookies.keys();
                        for (let i = 0; i < AllCookies.length; i++) {
                            if (AllCookies[i].includes(S_name2)) {
                                // if (AllCookies[i] == S_name_full) {
                                //  console.log("hii i am there ");
                                //} else {
                                this.old_qnt = this.$cookies.get(AllCookies[i]).quantity;
                                qun = qun - this.$cookies.get(AllCookies[i]).quantity;
                                min_qun = min_qun - this.$cookies.get(AllCookies[i]).quantity;
                                if (min_qun < 0) {
                                    min_qun = 1;
                                }
                                if (max_qun != -1)
                                    max_qun = max_qun - this.$cookies.get(AllCookies[i]).quantity;
                                if (max_qun == -1) {
                                    max_qun = -1;
                                }
                                else if (max_qun <= 0 && max_qun != -1) {
                                    max_qun = 0;
                                }

                                console.log(
                                    this.$cookies.get(AllCookies[i]).quantity + " quuuuunx " + qun
                                );
                                // }
                            }
                        }
                        this.quanity = qun;
                        this.max_quanity = max_qun;
                        this.min_quanity = min_qun;


                        //test
                        if (this.min_quanity > 0) {
                            this.counterVal = this.min_quanity;
                            this.price *= this.counterVal;
                            this.offer_price *= this.counterVal;
                        }
                        else {
                            this.counterVal = 1;
                            this.price *= this.counterVal;
                            this.offer_price *= this.counterVal;
                        }

                        //
                        this.loading_price = false;
                    });
            }
        },
        updateall() {
            //this.loading = true;
            for (var i = 0; i < collections.length; i++) {
                if (collections[i])
                    collections[i].classList.remove('active')
            }
            this.selectOption = false;
            this.counterVal = 1;
            this.options = [];
            this.selectedOptionArray = [];
            this.price = 0;
            this.offer_price = 0;
            this.quanity = 0;
            this.min_quanity = 0;
            this.max_quanity = 0;
            this.Firstquanity = 0;
            this.finalOptions = 0;
            this.checked = [];
            this.validateMessage = "";
            this.loading_price = true;

            this.axios
                .get(
                    this.$store.state.base_api_url +
                    this.$store.storeName +
                    "/product/theme5/" +
                    this.$route.params.id,
                    {
                        headers: {
                            "Accept-Language": this.$i18n.locale,
                            Authorization:
                                "Bearer " + this.$localStorage.get(this.$store.storeName)
                        }
                    }
                )
                .then(response => {
                    this.checked = [];
                    this.loading_price = false;
                    this.DBitems = response.data.data;
                    if (this.DBitems.product.seo_title)
                        document.title = this.DBitems.product.seo_title;
                    else
                        document.title = this.DBitems.product.name;
                    if (this.DBitems.product.seo_description)
                        document.getElementById("description_meta").content = this.DBitems.product.seo_description;
                    if (this.DBitems.product.seo_keyword)
                        document.getElementById("keywords_meta").content = this.DBitems.product.seo_keyword;
                    this.images = response.data.data.images.images;

                    this.fav = this.DBitems.product.is_favorit;
                    var option1 = this.DBitems.options.options;
                    for (var i = 0; i < option1.length; i++) {
                        //if option  not empty
                        if (option1[i].option_values.select_values != null) {
                            // if select
                            var element = {};
                            element.value_id = option1[i].option_values.select_values[0].id;
                            element.option_id = option1[i].id;
                            this.options.push(element);
                        } else {
                            // if checkbox
                            var checked = {};
                            checked.id = option1[i].id;
                            checked.value = false;
                            this.checked.push(checked);
                            //console.log(this.checked)
                        }
                    }
                    //console.log(this.options)
                })
                .then(() => {
                    this.loading = false;
                    if (this.options.length != 0) {
                        this.selectOption = true;

                    } else if (this.options.length == 0) {
                        // if we not found select options
                        console.log(
                            "hiiiiiiiiii updateall" + this.DBitems.product.sale_price
                        );
                        this.price = this.DBitems.product.sale_price;
                        this.offer_price = this.DBitems.product.offer_price;
                        this.min_quanity = 1;
                        if (this.DBitems.product.min_qnt)
                            this.min_quanity = this.DBitems.product.min_qnt;

                        this.max_quanity = this.DBitems.product.quantity;
                        if (this.DBitems.product.max_qnt > 0)
                            this.max_quanity = this.DBitems.product.max_qnt;

                        this.quanity = this.DBitems.product.quantity;
                        this.Firstquanity = this.DBitems.product.quantity;

                        /////////////nottttttttttttttttttteeeeeeeeeeeeeeeeeeee////////////
                        var checked_true = [];
                        for (var i = 0; i < this.checked.length; i++) {
                            if (this.checked[i].value == true) {
                                checked_true.push(this.checked[i].id);
                            }
                        }
                        let S_name_full =
                            this.$store.storeName +
                            "/" +
                            this.$route.params.id +
                            this.finalOptions +
                            checked_true;

                        let S_name2 =
                            this.$store.storeName +
                            "/" +
                            this.$route.params.id +
                            this.finalOptions;
                        console.log("S_name " + S_name2);

                        let qun = this.quanity;
                        let min_qun = this.min_quanity;
                        let max_qun = this.max_quanity;

                        let AllCookies = this.$cookies.keys();
                        for (let i = 0; i < AllCookies.length; i++) {
                            if (AllCookies[i].includes(S_name2)) {

                                console.log(
                                    " qnt " + qun
                                    + '<br> qnt_cookies ' + this.$cookies.get(AllCookies[i]).quantity
                                    + "<br> max_qnt " + max_qun
                                    + "<br> max_qnt cookies " + max_qun
                                );

                                this.old_qnt = this.$cookies.get(AllCookies[i]).quantity;
                                qun = qun - this.$cookies.get(AllCookies[i]).quantity;
                                min_qun = min_qun - this.$cookies.get(AllCookies[i]).quantity;
                                if (min_qun < 0) {
                                    min_qun = 1;
                                }
                                if (max_qun != -1)
                                    max_qun = max_qun - this.$cookies.get(AllCookies[i]).quantity;
                                if (max_qun == -1) {
                                    max_qun = -1;
                                }
                                else if (max_qun <= 0 && max_qun != -1) {
                                    max_qun = 0;
                                }
                                //this.$cookies.get(AllCookies[i]).quantity;
                                console.log(
                                    this.$cookies.get(AllCookies[i]).quantity + " quuuuuny  " + qun
                                    + "max_qnt " + max_qun
                                );
                                // }
                            }

                        }
                        this.quanity = qun;
                        this.min_quanity = min_qun;
                        this.max_quanity = max_qun;

                        if (this.min_quanity > 0) {
                            this.counterVal = this.min_quanity;
                            this.price *= this.counterVal;
                            this.offer_price *= this.counterVal;
                        }
                    }
                });
            var collections = document.getElementsByClassName("select_value_product");
            //option_value_radio
            for (var i = 0; i < collections.length; i++) {
                console.log("iii " + i)
                if (collections[i])
                    collections[i].classList.remove('active')
            }
            var collections2 = document.getElementsByClassName("option_value_radio");
            //option_value_radio
            for (var i = 0; i < collections2.length; i++) {
                console.log("iii2 " + i)
                if (collections2[i])
                    collections2[i].checked = false;
            }
        },
        addToCart() {

            this.loading_checkout = true;
            document.getElementById("icon_loading").style.display = "inline-block";
            document.getElementById("#addToCart").disabled = true;
            var checked_true = [];
            for (var i = 0; i < this.checked.length; i++) {
                if (this.checked[i].value == true) {
                    checked_true.push(this.checked[i].id);
                }
            }
            this.axios
                .post(
                    this.$store.state.base_api_url +
                    this.$store.storeName +
                    "/check_cart_item",
                    {
                        product_id: this.$route.params.id,
                        total_price: this.price,
                        offer_price: this.offer_price,
                        quantity: Number(this.counterVal),
                        old_qnt: this.old_qnt,
                        final_option: this.finalOptions,
                        option_check: checked_true
                    },
                    {
                        headers: {
                            "Accept-Language": this.$i18n.locale
                        }
                    }
                )
                .then(response => {
                    let product = null;
                    this.loading_checkout = false;
                    if (response.data.code == "1") {
                        // let products = new Map;
                        let S_name1 =
                            this.$store.storeName +
                            "/" +
                            this.$route.params.id +
                            this.finalOptions +
                            checked_true;
                        if (this.$cookies.isKey(S_name1)) {
                            console.log("$$$$$$$$$$", this.price, "$$$$$$$$$$$$$$$");
                            product = {
                                product_id: this.$route.params.id,
                                total_price:
                                    this.price + this.$cookies.get(S_name1).total_price,
                                offer_price:
                                    this.offer_price + this.$cookies.get(S_name1).offer_price,
                                quantity: Number(this.counterVal) + Number(this.$cookies.get(S_name1).quantity),
                                quantityAll: this.$cookies.get(S_name1).quantityAll,
                                max_quantity: this.$cookies.get(S_name1).max_quantity,
                                min_quantity: this.$cookies.get(S_name1).min_quantity,
                                final_option: this.finalOptions,
                                option_check: checked_true,
                                discount: this.DBitems.product.discount,
                                note: this.note + " " + this.$cookies.get(S_name1).note
                            };
                        } else {
                            console.log("hlooooooooooo ::::::::; " + this.Firstquanity);
                            product = {
                                product_id: this.$route.params.id,
                                total_price: this.price,
                                offer_price: this.offer_price,
                                quantity: this.counterVal,
                                quantityAll: this.Firstquanity,
                                min_quantity: this.min_quanity,
                                max_quantity: this.max_quanity,
                                final_option: this.finalOptions,
                                option_check: checked_true,
                                discount: this.DBitems.product.discount,
                                note: this.note
                            };
                        }
                        //check if item is exist on cart or not
                        //if (this.$cookies.isKey(this.$store.storeName+this.$route.params.id)) {
                        // this.$cookies.remove('storeName')
                        // products = this.$cookies.get(this.$store.storeName);
                        //}
                        //products.set(this.$route.params.id , product);
                        let S_name = this.$store.storeName + "/";

                        if (
                            !this.$cookies.isKey(
                                S_name +
                                product.product_id +
                                product.final_option +
                                product.option_check
                            )
                        ) {
                            this.$store.state.cartCounter = this.$store.state.cartCounter + 1;
                        }

                        this.$cookies.set(
                            S_name +
                            product.product_id +
                            product.final_option +
                            product.option_check,
                            product
                        );
                        console.log(this.$cookies.keys());
                    }
                    this.validateMessage = response.data.message;
                    /*this.$router.push({
                      name: "shoppingCart",
                      params: {
                        storeName: this.$store.storeName,
                      },
                    });*/
                    document.getElementById("icon_loading").style.display = "none";
                    document.getElementById("#addToCart").disabled = false;

                    this.updateall();

                    setTimeout(() => {
                        // this.updateall();
                        this.validateMessage = "";
                    }, 3000);
                });

        },
        addEvalu() {
            if (
                this.$localStorage.get(this.$store.storeName) != null &&
                this.DBitems.product.is_rate == true
            ) {
                this.addeval = true;
            } else if (
                this.$localStorage.get(this.$store.storeName) != null &&
                this.DBitems.product.is_rate == false
            ) {
                if (this.$i18n.locale == "en") {
                    document
                        .getElementsByClassName("hovertext")[0]
                        .setAttribute(
                            "data-hover",
                            "You must purchase the product to add a review"
                        );
                } else {
                    document
                        .getElementsByClassName("hovertext")[0]
                        .setAttribute("data-hover", "يجب أن تشتري المنتج لإضافة تقييم");
                }
            } else {
                if (this.$i18n.locale == "en") {
                    document
                        .getElementsByClassName("hovertext")[0]
                        .setAttribute("data-hover", "login to add evaluation");
                } else {
                    document
                        .getElementsByClassName("hovertext")[0]
                        .setAttribute("data-hover", "سجل دخول لإضافة تقييم");
                }
            }
        },
        changeFav() {
            if (this.$localStorage.get(this.$store.storeName) != null) {
                this.axios
                    .get(
                        this.$store.state.base_api_url +
                        this.$store.storeName +
                        "/favourite_product_change/" +
                        this.$route.params.id,
                        {
                            headers: {
                                "Accept-Language": this.$i18n.locale,
                                Authorization:
                                    "Bearer " + this.$localStorage.get(this.$store.storeName)
                            }
                        }
                    )
                    .then(response => {
                        if (response.data.code == "1") {
                            this.fav = !this.fav;
                        }
                    });
            } else {
                if (this.$i18n.locale == "en") {
                    this.loginMassage = "please Login";
                    setTimeout(() => {
                        this.loginMassage = "";
                    }, 3000);
                } else {
                    this.loginMassage = "يجب تسجيل الدخول";
                    setTimeout(() => {
                        this.loginMassage = "";
                    }, 3000);
                }
            }
        },
        changeCheckbox(item, val) {
            if (val) {
                this.price = this.price + item.price * this.counterVal;
                if (this.offer_price != 0) {
                    this.offer_price = this.offer_price + item.price * this.counterVal;
                }
            } else {
                /*(this.offer_price =
                    this.price - (this.DBitems.product.discount / 100) * this.price))*/
                this.price = this.price - item.price * this.counterVal;
                if (this.offer_price != 0) {
                    this.offer_price = this.offer_price - item.price * this.counterVal;
                }
                /*(this.offer_price =
                    this.price - (this.DBitems.product.discount / 100) * this.price));*/
            }
        },
        show_section(id) {

            document.getElementById('description').style = "display:none";
            document.getElementById('addinfo').style = "display:none";
            document.getElementById('review').style = "display:none";

            document.getElementById('description-tab').style = "color:black;background-color:transparent";
            document.getElementById('addinfo-tab').style = "color:black;background-color:transparent";
            document.getElementById('review-tab').style = "color:black;background-color:transparent";

            document.getElementById(id).style = "display:block !important";
            document.getElementById(id + '-tab').style = "color:white;background-color: var(--primary-color);";

        }
    },
    watch: {
        "$route.params": {
            handler(newValue) {
                this.Dbitems = null;
                this.loading = true;
                this.updateall();
            },
            immediate: true
        }
    }
};
</script>